var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.753418 4.965332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83232 1.24898C9.07582 0.416325 8.07529 0 6.83129 0C6.37303 0 5.95638 0.0568281 5.58178 0.170662C5.20705 0.284259 4.89074 0.443792 4.63237 0.649202C4.37418 0.854553 4.16853 1.04528 4.01583 1.22121C3.87071 1.38844 3.72876 1.5832 3.59021 1.8034L3.59021 0.252767L0 0.252767L0.0109195 0.78109C0.0183165 1.13337 0.0218976 2.2189 0.0218976 4.03811C0.0218976 5.85738 0.0147354 8.23043 0 11.1573L3.59021 11.1573L3.59021 5.07232C3.59021 4.69832 3.63007 4.40122 3.71026 4.18083C3.86314 3.80665 4.09385 3.49333 4.40324 3.24021C4.71262 2.98709 5.09621 2.86047 5.55465 2.86047C6.18017 2.86047 6.64038 3.0786 6.93503 3.51523C7.22962 3.95157 7.37697 4.55501 7.37697 5.32521L7.37697 11.1568L10.9672 11.1568L10.9672 4.90728C10.967 3.30059 10.5889 2.08145 9.83232 1.24898",
    transform: "translate(5.794434 4.996094)",
    id: "Fill-2",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9136L3.5679 10.9136L3.5679 0L0 0L0 10.9136Z",
    transform: "translate(0.2099609 5.239746)",
    id: "Fill-1",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02973 0C1.42593 0 0.936842 0.178061 0.561941 0.53377C0.187333 0.889419 0 1.33866 0 1.8816C0 2.41697 0.181932 2.86461 0.54562 3.22393C0.909191 3.58319 1.38953 3.76303 1.98593 3.76303L2.00777 3.76303C2.61902 3.76303 3.11187 3.58343 3.48653 3.22393C3.8612 2.86461 4.04472 2.41697 4.03756 1.8816C4.03039 1.33866 3.84464 0.889419 3.48096 0.53377C3.11744 0.177825 2.63353 0 2.02973 0",
    id: "Fill-5",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLinkedin);
export default __webpack_public_path__ + "static/media/ico-linkedin.92386c439cd5b7c0eb5c05fe91888eb6.svg";
export { ForwardRef as ReactComponent };